import { Swiper, Autoplay, Navigation } from '../vendor/swiper.js';
import {
    prefersNativeHomeScroll,
    onNativeCarouselBreakpoint,
    enableNativeHomeScroll,
    disableNativeHomeScroll,
} from './products-slider.js';

function bindReviewTextClamp(slider, swiper) {
  const cards = slider.querySelectorAll('.pdp-reviews__card');

  const apply = () => {
    cards.forEach((card) => {
      const text = card.querySelector('.pdp-reviews__text');
      const more = card.querySelector('.pdp-reviews__more');
      if (!(text instanceof HTMLElement) || !(more instanceof HTMLButtonElement)) {
        return;
      }
      if (more.dataset.bound === '1') {
        return;
      }

      const overflowing = text.scrollHeight > text.clientHeight + 1;
      if (!overflowing) {
        more.hidden = true;
        return;
      }

      more.hidden = false;
      more.dataset.bound = '1';
      more.addEventListener('click', () => {
        const expanded = text.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        more.textContent = expanded
          ? more.dataset.labelCollapse || 'свернуть'
          : more.dataset.labelExpand || 'ещё';
        if (swiper && !swiper.destroyed) {
          swiper.update();
        }
      });
    });
  };

  requestAnimationFrame(apply);
}

function ensureReviewsShell(el) {
  const existingShell = el.closest('.products-swiper-shell');

  if (existingShell instanceof HTMLElement) {
    const existingPrev = existingShell.querySelector('.swiper-button-prev');
    const existingNext = existingShell.querySelector('.swiper-button-next');

    if (
      existingPrev instanceof HTMLButtonElement &&
      existingNext instanceof HTMLButtonElement
    ) {
      return {
        shell: existingShell,
        prevEl: existingPrev,
        nextEl: existingNext,
      };
    }
  }

  const shell = document.createElement('div');
  shell.className = 'products-swiper-shell';

  el.parentNode.insertBefore(shell, el);
  shell.appendChild(el);

  const prevEl = document.createElement('button');
  prevEl.type = 'button';
  prevEl.className = 'swiper-button-prev';
  prevEl.setAttribute('aria-label', 'Назад');
  prevEl.innerHTML = `
    <svg width="6" height="12" aria-hidden="true" focusable="false">
        <use href="#icon-arrow-left" xlink:href="#icon-arrow-left"></use>
    </svg>
`;

  const nextEl = document.createElement('button');
  nextEl.type = 'button';
  nextEl.className = 'swiper-button-next';
  nextEl.setAttribute('aria-label', 'Вперёд');
  nextEl.innerHTML = `
    <svg width="6" height="12" aria-hidden="true" focusable="false">
        <use href="#icon-arrow-right" xlink:href="#icon-arrow-right"></use>
    </svg>
`;

  shell.append(prevEl, nextEl);

  return { shell, prevEl, nextEl };
}

function refreshPdpReviews() {
  initPdpReviews(document);
}

export function initPdpReviews(root = document) {
  const instances = [];
  const elements = root.querySelectorAll('[data-pdp-reviews-swiper]');

  onNativeCarouselBreakpoint(refreshPdpReviews);

  elements.forEach((el) => {
    if (!(el instanceof HTMLElement)) {
      return;
    }

    const slides = el.querySelectorAll(
      ':scope > .swiper-wrapper > .swiper-slide'
    );

    if (!slides.length) {
      return;
    }

    if (prefersNativeHomeScroll()) {
      if (el.swiper && !el.swiper.destroyed) {
        el.swiper.destroy(true, true);
        delete el.dataset.swiperInited;
      }
      enableNativeHomeScroll(el);
      bindReviewTextClamp(el, null);
      return;
    }

    disableNativeHomeScroll(el);

    if (el.dataset.swiperInited === '1' && el.swiper) {
      el.swiper.update();
      instances.push(el.swiper);
      return;
    }

    const { prevEl, nextEl } = ensureReviewsShell(el);

    /** @type {import('swiper').SwiperOptions} */
    const options = {
      modules: [ Navigation ],

      slidesPerView: 'auto',
      watchOverflow: true,
      observer: true,
      observeParents: true,

      loop: false,

      navigation: {
        prevEl,
        nextEl,
      },
    };

    if (el.dataset.autoplay === '1') {
      const delay = Number.parseInt(
        el.dataset.autoplayDelay || '2000',
        10
      );

      options.modules.push(Autoplay);

      options.autoplay = {
        delay: Number.isFinite(delay) && delay > 0 ? delay : 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    const instance = new Swiper(el, options);

    el.dataset.swiperInited = '1';
    bindReviewTextClamp(el, instance);
    instances.push(instance);
  });

  return instances;
}
